import { render, staticRenderFns } from "./GlSubText.vue?vue&type=template&id=30a3cebe&scoped=true&functional=true&"
var script = {}
import style0 from "./GlSubText.vue?vue&type=style&index=0&id=30a3cebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "30a3cebe",
  null
  
)

export default component.exports